import { useEffect } from "react";
import { toast } from "sonner";
import { ControlSessionEnvelope } from "../../models/audit/controlSession";

// Module scope rather than a ref: the session header remounts on every tab,
// and the toast should fire once per page load, not once per tab visited.
const reportedSessionIds = new Set<string>();

// Tells the user when the backend could not resolve the session's Optro link,
// which otherwise just looks like a session that is not linked.
export function useOptroLinkErrorToast(
  controlSession: ControlSessionEnvelope | null,
) {
  const sessionId = controlSession?.id;
  const optroLinkError = controlSession?.optroLinkError ?? false;

  useEffect(() => {
    if (!sessionId || !optroLinkError || reportedSessionIds.has(sessionId)) {
      return;
    }
    reportedSessionIds.add(sessionId);
    toast.error("Couldn't load the Optro link for this session.");
  }, [sessionId, optroLinkError]);
}
